import { LifeBuoy } from 'lucide-react';
import { useAuth } from '../auth/useAuth';
import { useMine } from './hooks';
import { useSupportForm } from './store';
import './support.css';

/**
 * Кнопка «Сообщить о проблеме» в шапке (`s737`). Видна каждому вошедшему
 * сотруднику на любой странице. На компьютере — в ряду приборов шапки, на
 * телефоне — отдельным значком в строке (приборы там убраны на полку).
 * Точка на кнопке — Семён ждёт ответа или просит проверить исправление.
 */
export function SupportHelpButton({ telefon = false }: { telefon?: boolean }) {
  const { user } = useAuth();
  const open = useSupportForm((s) => s.open);
  const setOpen = useSupportForm((s) => s.setOpen);
  const { data } = useMine(Boolean(user));

  if (!user) return null;

  const zhdut = (data?.incidents ?? []).filter(
    (i) => i.status === 'needs_reply' || ((i.status === 'released' || i.status === 'fixed') && !i.facts.human_confirmed_at),
  ).length;
  const podpis = zhdut > 0 ? 'Сообщить о проблеме · Семён ждёт вашего ответа' : 'Сообщить о проблеме';

  const knopka = (
    <button
      type="button"
      onClick={() => setOpen(!open)}
      aria-label={podpis}
      title={podpis}
      aria-expanded={open}
      data-testid={telefon ? 'support-help-tel' : 'support-help'}
      className={telefon
        ? `hdr-support-tel${open ? ' hdr-support-on' : ''}`
        : `hdr-btn hdr-support${open ? ' hdr-support-on' : ''}`}
    >
      <span className="hdr-support-ic">
        <LifeBuoy size={telefon ? 20 : 18} />
        {zhdut > 0 && <i aria-hidden />}
      </span>
      {!telefon && <span className="hdr-support-label">Сообщить о проблеме</span>}
    </button>
  );

  return telefon ? knopka : <div className="hdr-item" data-hdr="support">{knopka}</div>;
}
